import React from "react";
import { LanguageCode } from "../utils/translations";
import { HOME_COPY } from "../features/home/homeContent";

interface CustomerReviewsProps {
  lang: LanguageCode;
}

const CustomerReviews: React.FC<CustomerReviewsProps> = ({ lang }) => {
  const { title, items: reviews } = HOME_COPY[lang].reviews;

  return (
    <section
      style={{
        padding: "32px 5% 24px",
        backgroundColor: "#ffffff",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          fontSize: "28px",
          fontWeight: 900,
          color: "#714B67",
          marginBottom: "18px",
        }}
      >
        {title}
      </h2>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(300px, 1fr))",
          overflowX: "auto",
          gap: "16px",
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {reviews.map((review, index) => (
          <div
            key={index}
            style={{
              background: "#f8f9ff",
              padding: "16px",
              borderRadius: "16px",
              boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
            }}
          >
            <p style={{ marginBottom: "15px", color: "#444" }}>
              "{review.text}"
            </p>
            <strong style={{ color: "#017E84" }}>{review.name}</strong>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CustomerReviews;
